import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import SYPrimaryButton from "../../../components/SYPrimaryButton";
import Title from "../../../components/Title";
import {
  CSS_BREAKPOINTS_MIN,
  GREY_03_COLOR,
  GUTTER_SIZE,
  PAPER_WHITE_COLOR,
  SPACING_BASE,
  SPACING_NEXT_ELEMENT_MOBILE,
} from "../../../config/constants";
import SYProgressBar from "../../../components/SYProgressBar";
import urls from "../../../config/urls";
import UserUtils from "../../../utils/user.utils";
import CourseCompletionView from "../CourseCompletionView/CourseCompletionView";
import { ProgramWorkoutDetailView } from "../../../components/ProgramWorkoutDetailPageElements";
import GenericError from "../../../components/error/GenericError";
import SwitchModalView from "../SwitchModalView/SwitchModalView";
import { canUserWatchMasterClassWorkout } from "../../../modules/canUserWatchMasterClassWorkout";
import { useEffect, useState } from "react";
import LoadingAnimation from "../../../components/LoadingAnimation";
import { workoutsActionCreators } from "../../../store/actions/workout";
import { bindActionCreators } from "redux";
import { apiService } from "../../../services/APIService";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${GUTTER_SIZE * 2}px 0;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    padding: ${GUTTER_SIZE * 2.5}px 0 ${GUTTER_SIZE * 3.5}px;
  }
`;

const CardBackground = styled.div`
  display: flex;
  flex-direction: column;
  background: ${GREY_03_COLOR};
  padding: 24px 20px 32px 20px;
  margin: 20px;
`;

const CTA = styled(SYPrimaryButton)`
  width: 50%;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: auto;
    min-width: 50%;
  }
`;

const CTAContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: auto;
    min-width: 320px;
    display: flex;
  }

  @media ${CSS_BREAKPOINTS_MIN.md} {
    width: auto;
    display: inline-flex;
  }
`;

const AlignCenter = styled.div`
  align-self: center;
`;

const IMAGE_SIZE = 96;
const IMAGE_SIZE_SM = 96;
const IMAGE_LEFT = 65;

const ContainerImage = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: ${(props) =>
    IMAGE_SIZE * props.lengthImages -
    (IMAGE_SIZE - IMAGE_LEFT) * (props.lengthImages - 1)}px;
  flex-direction: row;
  margin-top: 20px;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: ${(props) =>
      IMAGE_SIZE_SM * props.lengthImages -
      (IMAGE_SIZE_SM - IMAGE_LEFT) * (props.lengthImages - 1)}px;
  }
`;

const Image = styled.img`
  position: ${(props) => (props.index === 0 ? "relative" : "absolute")};
  top: 0;
  left: ${(props) => props.index * IMAGE_LEFT}px;
  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE}px;
  border-radius: ${IMAGE_SIZE / 2}px;
  border: 4px solid #242526;
  z-index: ${(props) => Math.abs(props.index - (props.lengthImages ?? 0))};

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }
`;

const ProgressModal = (props) => {
  const { user } = props;
  console.log("user", user);
  const authors = props?.location?.state?.authors;
  const newActivePlan = props?.location?.state?.newActivePlan;
  const isFromRegularTrainingHome =
    props?.location?.state?.isFromRegularTrainingHome;
  console.log("ProgressModal newActivePlan: ", newActivePlan);
  console.log(
    "ProgressModal isFromRegularTrainingHome: ",
    isFromRegularTrainingHome
  );
  const [isFetching, setFetching] = useState(false);
  const [planInfo, setPlanInfo] = useState();
  const [purchasedThisCourse, setPurchasedThisCourse] = useState(false);

  useEffect(() => {
    console.log({ workoutId: newActivePlan?.nextWorkout?.id });
    props?.workoutActions.setNextWorkout({
      workoutId: newActivePlan?.nextWorkout?.id,
    });
  }, [newActivePlan?.nextWorkout?.id]);

  const onContinueClick = async () => {
    if (!!isFromRegularTrainingHome) {
      setFetching(true);
      const canAccessWorkout = await canUserWatchMasterClassWorkout({
        programId: newActivePlan?.id,
      });

      if (!user.isMasterClassUser) {
        setFetching(false);
        console.log(newActivePlan);
        props.history.push(urls.PAYWALL.replace(":slug", newActivePlan?.uid), {
          isFromRegularTrainingHome,
          backURL: `/master-class/workout-detail/${newActivePlan?.nextWorkout?.externalContentSlug}`,
        });
      } else {
        setFetching(false);
        props.history.push(urls.SWITCH_MODAL, {
          isFromRegularTrainingHome,
          courseSlug: newActivePlan?.uid,
        });
      }
    } else {
      props.history.replace(urls.TRAINING_HOME);
    }
  };

  useEffect(async () => {
    setFetching(true);
    const accessibleLog = await apiService.checkAccessiblePlanBySlug(
      newActivePlan?.externalContentSlug
    );
    const planInfo = {
      ...accessibleLog.planInfo,
      workouts: [...accessibleLog.accessibility].map((log) => {
        return {
          workoutData: {
            ...log.workoutInfo,
            done: log.done,
            canAccess: log.canAccess,
          },
        };
      }),
    };
    setFetching(false);
    setPlanInfo(planInfo);
  }, [newActivePlan?.externalContentSlug]);

  useEffect(async () => {
    if (!!user && !!newActivePlan?.externalContentSlug) {
      setFetching(true);
      try {
        // In case user didn't subscribe, try to find purchased items
        if (!user.isMasterClassUser) {
          const { purchasedItems } = await apiService.fetchPurchasedItems();
          console.log(purchasedItems);
          const plans = purchasedItems.map((i) => {
            return i.containedInPlans;
          });
          let planSlugs = _.flatten(
            plans.filter((p) => {
              return p.length > 0;
            })
          ).map((p) => p.externalContentSlug);
          planSlugs = _.without(_.uniq(planSlugs, "externalContentSlug"), null);
          const {
            match: {
              params: { slug: externalContentSlug },
            },
          } = props;
          if (!planSlugs.includes(externalContentSlug)) {
            props.history.push(urls.SWITCH_MODAL, {
              fromCourseDetailFTUE: true,
              courseSlug: newActivePlan?.externalContentSlug,
            });
          }
        }
      } catch (e) {
        console.log("--- user does not have purchased any single items");
      } finally {
        setFetching(false);
      }
    }
  }, [user.isMasterClassUser, newActivePlan?.externalContentSlug]);

  const courseLength = newActivePlan?.workouts?.length;

  const countDoneWorkout =
    planInfo?.workouts
      .map((w) => {
        return w.workoutData;
      })
      .filter((w) => {
        return w.done == 1;
      })?.length ?? 0;

  console.log({ countDoneWorkout });

  const isFinishCourse = countDoneWorkout == courseLength;

  if (isFetching || !planInfo) {
    return <LoadingAnimation />;
  }

  if (!newActivePlan) {
    return (
      <ProgramWorkoutDetailView
        style={{ paddingTop: SPACING_NEXT_ELEMENT_MOBILE }}
      >
        <GenericError
          error={{
            title: "Workout not found",
            message: `The workout was not found!`,
          }}
        />
      </ProgramWorkoutDetailView>
    );
  }

  // if (!isFromRegularTrainingHome && randomPosition == positionOfWorkout) {
  //   return <SwitchModalView />;
  // }

  if (isFinishCourse) {
    return <CourseCompletionView newActivePlan={newActivePlan} />;
  }

  return (
    <Container>
      <CardBackground>
        <AlignCenter>
          <ContainerImage lengthImages={authors?.results?.length}>
            {authors?.results?.map((avatarUrl, index) => {
              return (
                <Image
                  key={index}
                  index={index}
                  lengthImages={authors?.results?.length}
                  src={avatarUrl?.data?.author_avatar?.url}
                />
              );
            })}
          </ContainerImage>
        </AlignCenter>
        <Title
          fontsize={"13px"}
          marginTop={"16px"}
          lineHeight={"22px"}
          letterSpacing={"0.3px"}
          fontWeight={"300"}
          textAlign={"center"}
        >
          {`Nice work, ${UserUtils.getFirstName(user)}! You completed`}
        </Title>
        <Title
          fontsize={"20px"}
          marginTop={"20px"}
          marginBottom={"25px"}
          lineHeight={"25px"}
          letterSpacing={"0.4px"}
          color={PAPER_WHITE_COLOR}
          fontWeight={"500"}
          textAlign={"center"}
        >
          {`${
            newActivePlan?.nextWorkout?.name
          } of ${UserUtils.getDataMasterCourse(
            newActivePlan,
            "data.title[0].text"
          )}`}
        </Title>

        <SYProgressBar
          percentage={(countDoneWorkout / newActivePlan.workouts.length) * 100}
          height={1}
          style={{ marginBottom: SPACING_BASE * 5 }}
        />

        <Title
          fontsize={"13px"}
          marginTop={"10px"}
          lineHeight={"22px"}
          letterSpacing={"0.3px"}
          color={PAPER_WHITE_COLOR}
          fontWeight={"300"}
          textAlign={"center"}
        >
          {`${countDoneWorkout} class complete (${Math.floor(
            (countDoneWorkout / newActivePlan.workouts.length) * 100
          )}%), ${newActivePlan.workouts.length - countDoneWorkout} to go.`}
        </Title>
        <Title
          fontsize={"13px"}
          marginTop={"10px"}
          marginBottom={"30px"}
          lineHeight={"22px"}
          letterSpacing={"0.3px"}
          color={PAPER_WHITE_COLOR}
          fontWeight={"300"}
          textAlign={"center"}
        >
          Remember, yoga is 99% practice & 1% theory. Keep training every day to
          see improvement in your performance.
        </Title>
        <CTAContainer>
          <CTA title={"CONTINUE"} onClick={onContinueClick} />
        </CTAContainer>
      </CardBackground>
    </Container>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  workoutActions: bindActionCreators(workoutsActionCreators, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProgressModal)
);
